<template>
  <div>
    <div class="fw-bold fs-4 w-100">
      <div
        class="bg-white rounded-5 ps-2 pe-2 py-2 border-2 w-100 d-flex justify-content-between"
        :class="`${group}`"
      >
        <span class="bg-light rounded-5 p-1 py-0" v-if="icon"
          ><img style="width: 30px" :src="iconSrc" />
        </span>

        {{ title }}
        <span
          class="ms-2 text-white rounded-5 px-2"
          :class="`${group}-color`"
          >{{ entries.length }}</span
        >
      </div>
    </div>
    <div class="mt-3 rounded-5 bg-light border border-2 border-dark-subtle p-3">
      <div v-for="user in sortedEntries" :key="user.id">
        {{ user.value.fullname }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TeamBreakdown",
  props: {
    entries: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    group: {
      type: String,
      default: "bg-secondary"
    },
    icon: {
      type: String
    }
  },
  computed: {
    iconSrc() {
      if (!this.icon) return false;
      let src = `../assets/group-icons/${this.icon}`;
      return new URL(src, import.meta.url).href;
    },
    sortedEntries() {
      let entries = [...this.entries];
      return entries.sort((a, b) => {
        const extractLastSegment = (str) => {
          const segments = str.split(" "); // Split the string by the space delimiter
          return segments[segments.length - 1]; // Return the last segment
        };

        const lastNameA = extractLastSegment(a.value.fullname);
        const lastNameB = extractLastSegment(b.value.fullname);

        if (lastNameA < lastNameB) return -1;
        if (lastNameA > lastNameB) return 1;
        return 0;
      });
    }
  }
};
</script>
